import { defineStore } from 'pinia';

interface AlertState {
  code: any;
  errorMsg: string;
}

export const useAlertStore = defineStore('alert', {
  state: (): AlertState => ({
    code: null,
    errorMsg: '',
  }),

  actions: {
    openAlert(payload: any) {
      this.code = payload;
    },
    updateErrorMsg(payload: string) {
      this.errorMsg = payload || '';
    },
  },
});
